// Video wall layout: the wall canvas is `columns × rows` tiles of `tileWidth × tileHeight` with
// `gapX`/`gapY` hidden pixels between neighbours (the bezels), so a picture continues behind them.

// Bundle FitMode → how media fits the canvas.
const FIT_CLASSES = {
  1: 'object-cover',
  2: 'object-contain',
  3: 'object-fill',
};

export const fitClass = (fitMode) => FIT_CLASSES[fitMode] ?? 'object-cover';

export const canvasSize = ({
  rows,
  columns,
  tileWidth,
  tileHeight,
  gapX = 0,
  gapY = 0,
}) => ({
  width: columns * tileWidth + (columns - 1) * gapX,
  height: rows * tileHeight + (rows - 1) * gapY,
});

/**
 * Where this tile's slice of the canvas goes on a `viewport` (the screen, in CSS pixels).
 * `clip` is the on-screen box the tile fills (scaled to fit, centred when the screen's aspect
 * ratio differs from the tile's). `canvas` is the transform that puts the tile's slice of the
 * canvas into that box: `scale(scale) translate(-x px, -y px)` from the top-left corner.
 */
export const tileLayout = (wall, viewport) => {
  const {
    tileWidth,
    tileHeight,
    gapX = 0,
    gapY = 0,
    row = 0,
    column = 0,
  } = wall;
  const scale = Math.min(
    viewport.width / tileWidth,
    viewport.height / tileHeight,
  );
  const width = tileWidth * scale;
  const height = tileHeight * scale;
  return {
    clip: {
      left: (viewport.width - width) / 2,
      top: (viewport.height - height) / 2,
      width,
      height,
    },
    canvas: {
      ...canvasSize(wall),
      scale,
      x: column * (tileWidth + gapX),
      y: row * (tileHeight + gapY),
    },
  };
};
